"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = Medium;

var _react = _interopRequireDefault(require("react"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");

var _text = require("@mmc/text");

var _medium = _interopRequireDefault(require("../../styles/layouts/medium.css"));

var _cardContent = _interopRequireDefault(require("../card-content"));

var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp,
    appendImageOptimization = dataUtils.appendImageOptimization;

var renderOverlayImage = function renderOverlayImage(image, alt) {
  var imageWidth = 960;
  var isBackground = false;
  var isWebp = true;
  var imageQuality = 70;

  if (image !== ' ') {
    return /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
      className: _medium["default"].overlayImage,
      src: appendImageOptimization(image, imageWidth, isBackground, isWebp, imageQuality),
      srcSet: [appendImageOptimization(image, 240, isBackground, isWebp, imageQuality) + " 240w", appendImageOptimization(image, 480, isBackground, isWebp, imageQuality) + " 480w", appendImageOptimization(image, 720, isBackground, isWebp, imageQuality) + " 720w", appendImageOptimization(image, 1080, isBackground, isWebp, imageQuality) + " 1080w", appendImageOptimization(image, 1440, isBackground, isWebp, imageQuality) + " 1440w", appendImageOptimization(image, 2160, isBackground, isWebp, imageQuality) + " 2160w"].join(','),
      sizes: "(min-width: 768px) 40vw, 100vw",
      alt: alt
    });
  }

  return null;
};

var isImageMissing = function isImageMissing(column) {
  return handleNestedProp(column, 'column.image.image') === ' ' || handleNestedProp(column, 'column.image.image') === null || handleNestedProp(column, 'column.image.image') === '';
};

var isDescriptionHeadingMissing = function isDescriptionHeadingMissing(column) {
  return handleNestedProp(column, 'column.description.sectionHeading') === ' ' || handleNestedProp(column, 'column.description.sectionHeading') === null || handleNestedProp(column, 'column.description.sectionHeading') === '';
};

var isDescriptionParagraphMissing = function isDescriptionParagraphMissing(column) {
  return handleNestedProp(column, 'column.description.paragraph') === ' ' || handleNestedProp(column, 'column.description.paragraph') === null || handleNestedProp(column, 'column.description.paragraph') === '';
};

function Medium(_ref) {
  var theme = _ref.theme,
      columns = _ref.columns,
      editorialLayout = _ref.editorialLayout,
      disclaimerData = _ref.disclaimerData,
      addPriceDisclaimer = _ref.addPriceDisclaimer,
      priceDisclaimerId = _ref.priceDisclaimerId,
      market = _ref.market;

  var pushDataToDatalayer = function pushDataToDatalayer(contentObj) {
    if (market.toLowerCase() === 'nl' && typeof window !== 'undefined' && window.dataLayer && window.location.pathname && window.location.pathname.includes('/brochuredownload') //to check url
    ) {
      var model = handleNestedProp(contentObj, 'contentObj.description.mainHeading');
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        brochureDownload: model
      });
    }
  };

  var renderColumns = function renderColumns(themeStyles, columnsArr) {
    return columnsArr && columnsArr.map(function (column, i) {
      var imageIsMissing = isImageMissing(column);
      var descriptionHeadingIsMissing = isDescriptionHeadingMissing(column);
      var descriptionParagraphIsMissing = isDescriptionParagraphMissing(column);
      var linkMissing = handleNestedProp(column, 'column.link.url') === ' ' || handleNestedProp(column, 'column.link.url') === null || handleNestedProp(column, 'column.link.url') === '';
      var openInNewTab = handleNestedProp(column, 'column.link.openNewTab');
      var imageSrc = handleNestedProp(column, 'column.image.image');
      var altText = handleNestedProp(column, 'column.image.altText');
      var imageWidth = 720;
      var isBackground = false;
      var isWebp = true;
      var imageQuality = 70;

      if (imageIsMissing && descriptionHeadingIsMissing && descriptionParagraphIsMissing) {
        return '';
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        // eslint-disable-next-line react/no-array-index-key
        key: i,
        className: themeStyles['col-xs-12'] + " " + themeStyles['col-sm-4'] + " " + _medium["default"].columnWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _medium["default"].imageWrapper + " " + theme.marginBottom20
      }, !imageIsMissing && !linkMissing && (openInNewTab ? /*#__PURE__*/_react["default"].createElement("a", {
        onClick: function onClick() {
          return pushDataToDatalayer(column);
        },
        href: handleNestedProp(column, 'column.link.url'),
        className: "" + _medium["default"].imageLink,
        target: "_blank",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
        className: _medium["default"].image,
        src: appendImageOptimization(imageSrc, imageWidth, isBackground, isWebp, imageQuality),
        srcSet: [appendImageOptimization(imageSrc, 240, isBackground, isWebp, imageQuality) + " 240w", appendImageOptimization(imageSrc, 480, isBackground, isWebp, imageQuality) + " 480w", appendImageOptimization(imageSrc, 720, isBackground, isWebp, imageQuality) + " 720w", appendImageOptimization(imageSrc, 1080, isBackground, isWebp, imageQuality) + " 1080w", appendImageOptimization(imageSrc, 1440, isBackground, isWebp, imageQuality) + " 1440w", appendImageOptimization(imageSrc, 2160, isBackground, isWebp, imageQuality) + " 2160w"].join(','),
        sizes: "(min-width: 768px) 40vw, 100vw",
        alt: altText
      })) : /*#__PURE__*/_react["default"].createElement("a", {
        onClick: function onClick() {
          return pushDataToDatalayer(column);
        },
        href: handleNestedProp(column, 'column.link.url'),
        className: _medium["default"].imageLink + " " + _medium["default"].imageLinkAtag
      }, /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
        className: _medium["default"].image,
        src: appendImageOptimization(imageSrc, imageWidth, isBackground, isWebp, imageQuality),
        srcSet: [appendImageOptimization(imageSrc, 240, isBackground, isWebp, imageQuality) + " 240w", appendImageOptimization(imageSrc, 480, isBackground, isWebp, imageQuality) + " 480w", appendImageOptimization(imageSrc, 720, isBackground, isWebp, imageQuality) + " 720w", appendImageOptimization(imageSrc, 1080, isBackground, isWebp, imageQuality) + " 1080w", appendImageOptimization(imageSrc, 1440, isBackground, isWebp, imageQuality) + " 1440w", appendImageOptimization(imageSrc, 2160, isBackground, isWebp, imageQuality) + " 2160w"].join(','),
        sizes: "(min-width: 768px) 40vw, 100vw",
        alt: altText
      }))), !imageIsMissing && linkMissing && /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
        className: _medium["default"].image,
        src: appendImageOptimization(imageSrc, imageWidth, isBackground, isWebp, imageQuality),
        srcSet: [appendImageOptimization(imageSrc, 240, isBackground, isWebp, imageQuality) + " 240w", appendImageOptimization(imageSrc, 480, isBackground, isWebp, imageQuality) + " 480w", appendImageOptimization(imageSrc, 720, isBackground, isWebp, imageQuality) + " 720w", appendImageOptimization(imageSrc, 1080, isBackground, isWebp, imageQuality) + " 1080w", appendImageOptimization(imageSrc, 1440, isBackground, isWebp, imageQuality) + " 1440w", appendImageOptimization(imageSrc, 2160, isBackground, isWebp, imageQuality) + " 2160w"].join(','),
        sizes: "(min-width: 768px) 40vw, 100vw",
        alt: altText
      }), renderOverlayImage(handleNestedProp(column, 'column.overlayImage.image'), handleNestedProp(column, 'column.overlayImage.altText'))), /*#__PURE__*/_react["default"].createElement(_cardContent["default"], {
        theme: themeStyles,
        content: column,
        editorialLayout: editorialLayout,
        disclaimerData: disclaimerData,
        addPriceDisclaimer: addPriceDisclaimer,
        priceDisclaimerId: priceDisclaimerId
      }));
    });
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['container-fluid'] + " " + _medium["default"].wrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.row
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-lg-1'] + " " + _medium["default"].sidePanel
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-12'] + " " + theme['col-lg-10']
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['container-fluid'] + " " + _medium["default"].innerWrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.row
  }, renderColumns(theme, columns)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-lg-1'] + " " + _medium["default"].sidePanel
  })));
}

Medium.displayName = 'Medium';